import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { getValueByLanguage } from '@hooks/useLocalization';

const Works = ({ works, is_fetching_works, fetch, title, path }) => {
  const { language } = useSelector((state) => state.config);

  const localized_works = (translateObj, key) => {
    return getValueByLanguage(translateObj, key, language);
  };

  const [expandedItems, setExpandedItems] = useState({});

  // Toggle the visibility of sub-items when clicking an item
  const toggleSubItems = (itemId) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  return (
    <div className="page-3">
      <div className="works__container">
        <h2 style={{ fontWeight: '600' }}>{title}</h2>
        <div id="sub__menu__items" style={{ fontWeight: '300' }}>
          {works?.map((work) => (
            <>
              <div className="work__categories" key={work.id}>
                {work.items && (
                  <>
                    <div
                      onClick={() => toggleSubItems(work.id)}
                      onKeyDown={(event) => {
                        // if (event.key === 'Enter') toggleSubItems(work.id);
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <h2>{work.title}</h2>
                    </div>
                    {expandedItems[work.id] &&
                      work.items.map((subItem) => {
                        return (
                          <div
                            key={subItem.id}
                            data-menu
                            data-id={subItem.id}
                            className="work__categories"
                          >
                            <h2>
                              <a
                                key={subItem.id}
                                className="work__categories__item work__categories__subitem"
                                custom-link
                                href={`${path}/${subItem.slug}`}
                                onclick="event.preventDefault()"
                              >
                                {localized_works(subItem, 'title')}
                              </a>
                            </h2>
                          </div>
                        );
                      })}
                  </>
                )}

                {!work.items && (
                  <div
                    data-menu
                    data-id={work.id}
                    className="work__categories"
                    style={{
                      visibility: Object.values(expandedItems).some(
                        (value) => value,
                      )
                        ? 'hidden'
                        : 'visible',
                    }}
                  >
                    <h2>
                      <a
                        key={work.id}
                        className="work__categories__item"
                        custom-link
                        href={`${path}/${work.slug}`}
                        onclick="event.preventDefault()"
                      >
                        {localized_works(work, 'title')}
                      </a>
                    </h2>
                  </div>
                )}
              </div>
            </>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Works;
